/**
 * GP feature-flag names, shared between this repo's libraries and the apps that
 * consume them (global-dash-fe, apps/demo). Libraries read a flag with
 * `useFeatureFlag().isEnabled(GpFeature.X)`; each app owns its own enablement
 * (feature map). The string value must match the key the apps register — it is
 * a contract, not a display label. See docs/adr/0021.
 */
export const GpFeature = {
  XemploPay: 'XemploPay',
} as const;

export type GpFeature = (typeof GpFeature)[keyof typeof GpFeature];
